import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  supportController: [
    'runtimeConstant',
    '$scope',
    '$filter',
    '$uibModalInstance',
    'supportService',
    function (
      runtimeConstant,
      $scope,
      $filter,
      $uibModalInstance,
      supportService
    ) {
      'use strict';

      function cancel() {
        $uibModalInstance.dismiss('cancel');
      }

      function encodeImageFileAsURL() {
        var element = document.getElementById('image');
        var file = element.files[0];
        var reader = new FileReader();
        reader.onloadend = function () {
          $scope.imageFile = reader.result;
          var block = $scope.imageFile.split(';');
          var contentType = block[0].split(':')[1];
          var realData = block[1].split(',')[1];
          $scope.base64toBlob(realData, contentType);
        };
        reader.readAsDataURL(file);
      }

      function base64toBlob(b64Data, contentType = '', sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        $scope.imageFileBlob = blob;
      }

      function support() {
        $scope.askToSuport();
        $scope.userDoubt = null;
        $scope.sendImage = false;
      }

      function askToSuport() {
        supportService
          .openNewSupportTicket(
            $scope.user.name +
              '\r\n' +
              $scope.user.email +
              '\r\n' +
              $scope.userDoubt
          )
          .then(() => {
            swal.fire({
              title: $filter('translate')('SUCCESS MESSAGE'),
              text: $filter('translate')('AWAIT SUCCESS'),
              icon: 'success',
              showConfirmButton: true,
            });
            $scope.cancel();
          })
          .catch((err) => {
            swal.fire({
              title: err + '!\n' + $filter('translate')('AN ERROR OCCURRED'),
              text: $filter('translate')('AWAIT ERROR'),
              icon: 'error',
              showConfirmButton: true,
            });
          });
      }

      function run() {
        try {
          $scope.userDoubt = null;
          $scope.sendImage = false;
          $scope.imageFile = null;
          $scope.imageFileBlob = null;

          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.encodeImageFileAsURL = logWrapper(
            encodeImageFileAsURL,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.base64toBlob = logWrapper(
            base64toBlob,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.support = logWrapper(
            support,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.askToSuport = logWrapper(
            askToSuport,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
